let osanoConsentExpected = false;

/**
 * Records that this page will load Osano CMP (client script injection).
 * Call from the Osano consent loader module so analytics init waits for
 * `withCMP` instead of loading Segment ungated before scripts exist.
 */
function markOsanoConsentExpected(): void {
  osanoConsentExpected = true;
}

function isOsanoConsentExpected(): boolean {
  return osanoConsentExpected;
}

export { isOsanoConsentExpected, markOsanoConsentExpected };
